/**
 * Textos do dropdown de país (busca / vazio / aria do trigger).
 * Mantido aqui para não inflar contactFormCopy e manter o campo autocontido.
 */
const TABLE = {
  'pt-BR': {
    searchPlaceholder: 'Buscar país, código ou DDI…',
    empty: 'Nenhum país encontrado.',
    selectPrefix: 'Selecionar país. Atual:'
  },
  'pt-PT': {
    searchPlaceholder: 'Pesquisar país, código ou indicativo…',
    empty: 'Nenhum país encontrado.',
    selectPrefix: 'Selecionar país. Atual:'
  },
  en: {
    searchPlaceholder: 'Search country, code or prefix…',
    empty: 'No country found.',
    selectPrefix: 'Select country. Current:'
  },
  es: {
    searchPlaceholder: 'Buscar país, código o prefijo…',
    empty: 'Ningún país encontrado.',
    selectPrefix: 'Seleccionar país. Actual:'
  },
  fr: {
    searchPlaceholder: 'Rechercher pays, code ou indicatif…',
    empty: 'Aucun pays trouvé.',
    selectPrefix: 'Choisir le pays. Actuel :'
  },
  it: {
    searchPlaceholder: 'Cerca paese, codice o prefisso…',
    empty: 'Nessun paese trovato.',
    selectPrefix: 'Seleziona paese. Attuale:'
  },
  hi: {
    searchPlaceholder: 'देश, कोड या कोड खोजें…',
    empty: 'कोई देश नहीं मिला।',
    selectPrefix: 'देश चुनें। वर्तमान:'
  },
  de: {
    searchPlaceholder: 'Land, Code oder Vorwahl suchen…',
    empty: 'Kein Land gefunden.',
    selectPrefix: 'Land wählen. Aktuell:'
  },
  nl: {
    searchPlaceholder: 'Zoek land, code of netnummer…',
    empty: 'Geen land gevonden.',
    selectPrefix: 'Land kiezen. Huidig:'
  },
  ru: {
    searchPlaceholder: 'Поиск страны, кода или кода…',
    empty: 'Страна не найдена.',
    selectPrefix: 'Выбрать страну. Сейчас:'
  },
  ar: {
    searchPlaceholder: 'ابحث عن الدولة أو الرمز أو المقدمة…',
    empty: 'لم يُعثر على دولة.',
    selectPrefix: 'اختر الدولة. الحالية:'
  },
  'zh-CN': {
    searchPlaceholder: '搜索国家、代码或区号…',
    empty: '未找到国家。',
    selectPrefix: '选择国家。当前：'
  },
  'zh-TW': {
    searchPlaceholder: '搜尋國家、代碼或區碼…',
    empty: '找不到國家。',
    selectPrefix: '選擇國家。目前：'
  }
};

export function getPhoneUiStrings(language) {
  return TABLE[language] || TABLE.en;
}

export function buildTriggerAriaLabel(strings, row) {
  if (!row) return strings.selectPrefix;
  return `${strings.selectPrefix} ${row.name} +${row.dialCode}`;
}
